import { useMutation } from "@tanstack/react-query";
import { axiosReq } from "@/lib/axios";
import posthog from "posthog-js";
import { toast } from "sonner";

type ImageUploadArgs = {
  catalogue: string,
  user: string,
  media_file: File,
  prompt: string
}

export const useUploadPostImage = () => {

  const request = async (data: ImageUploadArgs): Promise<{
    image_path: string,
    image_id: number
  }> => {

    const config = {
      headers: {
        'Content-Type': 'multipart/form-data',
      },
    };

    const response = await axiosReq.post('/api/approval/upload-post-media/', data, config);
    return response.data;
  };

  const { mutate: uploadImage, data, isSuccess, isPending } = useMutation({
    mutationFn: request,
    onSuccess: (data) => {
      posthog.capture('image uploaded by user', { image: data.image_id })
      toast.success("Image uploaded successfully");
      return data;
    },
    onError: (error) => {
      toast.error("Failed to upload image");
      console.error("Image upload error:", error);
    }
  });

  return { uploadImage, isSuccess, data, isPending };
};

